<template>
  <div class="carousel_div">
    <v-flex xs12 sm12 md12 lg12>
      <v-carousel
        class="carousel"
        height="100vh"
        hide-delimiters
        interval="4000"
        :cycle="play_com"
        continuous
      >
        <v-carousel-item
          v-for="(item,i) in selected"
          :key="i"
          transition="fade"
          reverse-transition="fade"
        >
          <v-img contain height="100%" :src="item[0]">
            <div class="controls">
              <v-layout row>
                <v-col cols="10"></v-col>
                <v-col cols="2">
                  <i class="mr-5" @click="play=!play" style="color:white" :class="playPause"></i>
                  <router-link
                    style="text-decoration: none"
                    :to="{ name: 'TravelPhotos', params: {id: voyid} }"
                  >
                    <v-icon color="white">mdi-close</v-icon>
                  </router-link>
                </v-col>
              </v-layout>
            </div>
          </v-img>
        </v-carousel-item>
      </v-carousel>
    </v-flex>
  </div>
</template>

<script>
import {mapState} from 'vuex'
export default {
  name: "Carousel",
  data() {
    return {
      index: this.$route.params.index,
      voyid: this.$route.params.id,
      cycle: false,
      play: false,
      lang: this.$route.params.lang
    };
  },
  computed: {
    ...mapState([
      'carouselTravel'
    ]),
    selected() {
      var ind = 0
      while(this.carouselTravel[ind][1] != this.index){
        ind ++
      }
      var res = []
      for(var i=0; i<this.carouselTravel.length; i++){
        res.push(this.carouselTravel[(i+ind)%this.carouselTravel.length])
      }
      return res
    },
    playPause() {
      if (!this.play) {
        return "fa fa-play";
      }
      return "fa fa-pause";
    },
    play_com() {
      if (this.play) return true;
      return false;
    }
  },
  methods: {
    update() {
      this.voyid = this.$route.params.id;
      this.index = this.$route.params.index;
    }
  },
  watch: {
    $route: "update"
  },
  mounted() {
  }
};
</script>

<style scoped>
.carousel_div {
  background-color: black;
  width: 100%;
  height: 100vh;
}

.carousel {
  height: 100vh;
}

.controls {
  background-image: linear-gradient(rgba(0, 0, 0, 0.726), rgba(0, 0, 0, 0.726));
  width: 100%;
  height: 5%;
  margin-left: 100px;
}
</style>